module.exports = __webpack_public_path__ + "img/copyright-pdf.0bd898f5.png";